import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../../../Utils";
import SyntheseRecettes from "../../Dashboard/Syntheses/SyntheseRecettes";
import ProspectGeneralStats from "./ProspectGeneralStats";
import ProspectSourceStats from "./ProspectSourceStats";
import { getProspectStats } from "../../../REDUX/actions/prospects";
import { useTranslation } from "react-i18next";

const ProspectStats = ({ filters, userRole }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const { stats } = useSelector((state) => state.prospectsReducer);
  const generalStats = [
    {
      label: t("Nber of Prospect Stores"),
      value: stats.count ?? "-",
      bgColor: "#577b87",
    },
    {
      label: t("Potential Spa/year Prospect"),
      value: stats.annualSpaPotential ?? "-",
      bgColor: "#94adb2",
    },
    {
      label: t("Potential Revenue/year Prospect"),
      value: stats.annualTOPotential
        ? formatCurrency(stats.annualTOPotential)
        : "-",
      bgColor: "#cfd5d6",
    },
  ];

  const types = [
    "Total",
    "Nuturing",
    "Call",
    "Email",
    "Prospecting Visit",
    "In-store Appointment_",
    "Video Appointment_",
    "Sending the Contract",
  ];

  const transformedActions = {
    ...(stats?.actions || {}),
    "Video Appointment_": stats?.actions
      ? stats?.actions["Video Appointment"]
      : {},
    "In-store Appointment_": stats?.actions
      ? stats?.actions["In-store Appointment"]
      : {},
  };

  const abortControllerRef = useRef(null);

  useEffect(() => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    dispatch(getProspectStats(filters, abortControllerRef.current.signal));
    return () => {
      abortControllerRef.current?.abort();
    };
  }, [dispatch, filters]);

  return (
    <div>
      <ProspectGeneralStats generalStats={generalStats} userRole={userRole} />
      <div className="gap-4 w-100 d-flex">
        <div className="w-50">
          <SyntheseRecettes
            title={t("Action Summary")}
            stats={transformedActions}
            tabs={types}
            noUnity
          />
        </div>
        <div className="d-flex w-50">
          <ProspectSourceStats data={stats?.source} />
        </div>
      </div>
    </div>
  );
};

export default ProspectStats;
